import { cn } from "@nexxt/ui";
import type { ReactNode } from "react";

/** A problem said next to what caused it (a form, a dialog, a panel), announced as soon as it appears. */
export function ErrorLine({ children, className }: { children: ReactNode; className?: string | undefined }) {
  return (
    <p role="alert" className={cn("text-sm text-danger-fg", className)}>
      {children}
    </p>
  );
}
